/**********************************************************************
 * Copyright (C) 2026 Red Hat, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * SPDX-License-Identifier: Apache-2.0
 ***********************************************************************/

enum RegistryLabels {
  PREFERRED = 'Preferred',
  MANAGED = 'Managed',
  REGISTRY_LOCATION = 'Registry Location',
  USERNAME = 'Username',
  PASSWORD = 'Password',
}

enum RegistryButtons {
  CONFIGURE = 'Configure',
}

enum RegistryMenuItems {
  LOGIN = 'Login',
  EDIT_PASSWORD = 'Edit password',
  REMOVE = 'Remove',
}

export class Registries {
  static readonly Labels = RegistryLabels;
  static readonly Buttons = RegistryButtons;
  static readonly MenuItems = RegistryMenuItems;

  // Field configuration
  static readonly PREFERRED_INPUT_NAME = 'registries.preferred';
  static readonly PREFERRED_PLACEHOLDER = 'quay.io, ghcr.io';

  // Table
  static readonly TABLE_ARIA_LABEL = 'Registries';
}
